module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/15.f63b76d7.jpg";